/**
 * Simple catcher/bags buy box: colour, optional bag pack, add to cart.
 */
(function () {
  if (window.__swoopProductSimple) return;
  window.__swoopProductSimple = true;

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function family(name) {
    if (window.SwoopColor && typeof window.SwoopColor.family === 'function') {
      return window.SwoopColor.family(name) || '';
    }
    var c = String(name || '').toLowerCase();
    if (/turquoise|teal|swoopman|cyan/.test(c)) return 'teal';
    if (/pink|rose|poupette|magenta|fuchsia/.test(c)) return 'pink';
    return c;
  }

  function colorMatch(a, b) {
    if (window.SwoopColor && typeof window.SwoopColor.match === 'function') {
      return !!window.SwoopColor.match(a, b);
    }
    return family(a) && family(a) === family(b);
  }

  function money(cents) {
    if (window.SwoopMoney && typeof window.SwoopMoney.format === 'function') {
      return window.SwoopMoney.format(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (Number(cents || 0) / 100).toFixed(2);
  }

  function sizeKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/bags?/g, '')
      .replace(/[^0-9]/g, '');
  }

  function packSizeKey(size) {
    var n = parseInt(size, 10);
    if (n === 90 || n === 180) return String(n);
    var s = String(size || '').toLowerCase();
    if (s.indexOf('90') !== -1) return '90';
    if (s.indexOf('180') !== -1) return '180';
    return sizeKey(size);
  }

  function planText(plan) {
    var parts = [plan && plan.name];
    var opts = (plan && plan.options) || [];
    var i;
    for (i = 0; i < opts.length; i++) {
      if (typeof opts[i] === 'string') parts.push(opts[i]);
      else if (opts[i] && opts[i].value) parts.push(opts[i].value);
    }
    return parts.join(' ').toLowerCase();
  }

  function planTokensForSize(sizeKeyValue) {
    if (sizeKeyValue === '90') {
      return {
        prefer: [/4[\s-]*week/, /4[\s-]*semaine/, /4[\s-]*woche/, /4[\s-]*wochen/],
        avoid: [/3[\s-]*month/, /3[\s-]*mois/, /3[\s-]*monat/, /12[\s-]*week/, /6[\s-]*month/, /5[\s-]*week/]
      };
    }
    if (sizeKeyValue === '180') {
      return {
        prefer: [/3[\s-]*month/, /3[\s-]*mois/, /3[\s-]*monat/, /12[\s-]*week/, /12[\s-]*semaine/],
        avoid: [/4[\s-]*week/, /5[\s-]*week/, /6[\s-]*month/, /12[\s-]*month/]
      };
    }
    return { prefer: [], avoid: [] };
  }

  function matchBagPlan(plans, size) {
    var list = plans || [];
    if (!list.length) return null;
    var tokens = planTokensForSize(packSizeKey(size));
    var scored = list.map(function (plan) {
      var text = planText(plan);
      var score = 0;
      tokens.prefer.forEach(function (re) {
        if (re.test(text)) score += 100;
      });
      tokens.avoid.forEach(function (re) {
        if (re.test(text)) score -= 80;
      });
      if (/off for 1|1 order|first order|intro/.test(text)) score -= 15;
      return { plan: plan, score: score };
    }).sort(function (a, b) {
      return b.score - a.score;
    });
    if (scored[0] && scored[0].score > 0) return scored[0].plan;
    if (list.length === 1) return list[0];
    return null;
  }

  function parseMap(root) {
    var el = qs(root, '[data-sps-map]');
    if (!el) return { catcher: [], bags: [] };
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (err) {
      return { catcher: [], bags: [] };
    }
  }

  function findCatcher(map, color) {
    var list = (map && map.catcher) || [];
    return (
      list.find(function (v) {
        return colorMatch(v.color, color) || v.color === color;
      }) ||
      list[0] ||
      null
    );
  }

  function findBag(map, color, size) {
    var key = sizeKey(size);
    var list = (map && map.bags) || [];
    return (
      list.find(function (v) {
        return sizeKey(v.size) === key && (colorMatch(v.color, color) || !v.color);
      }) ||
      list.find(function (v) {
        return sizeKey(v.size) === key;
      }) ||
      null
    );
  }

  function setText(el, value) {
    if (el) el.textContent = value || '';
  }

  function setMoney(el, cents, hideEmpty) {
    if (!el) return;
    if (!cents || Number(cents) <= 0) {
      el.textContent = '';
      if (hideEmpty) el.hidden = true;
      return;
    }
    el.hidden = false;
    el.textContent = money(cents);
  }

  function applyTheme(color) {
    var fam = family(color);
    document.documentElement.setAttribute('data-snx-theme', fam === 'pink' ? 'pink' : 'teal');
  }

  function initGallery(root) {
    qsa(root, '[data-snx-gallery-set]').forEach(function (set) {
      if (set.getAttribute('data-snx-gallery-ready')) return;
      var track = qs(set, '[data-snx-gallery-track]');
      var slides = qsa(set, '[data-snx-slide]');
      var thumbs = qsa(set, '[data-snx-thumb]');
      var indexEl = qs(set, '[data-snx-gallery-index]');
      var dots = qsa(set, '[data-snx-dot]');
      if (!track || !slides.length) return;
      set.setAttribute('data-snx-gallery-ready', '1');

      function desktopGallery() {
        return window.matchMedia('(min-width: 990px)').matches;
      }

      function indexFromScroll() {
        var left = track.getBoundingClientRect().left + 24;
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, i) {
          var media = slide.querySelector('img, video') || slide;
          var dist = Math.abs(media.getBoundingClientRect().left - left);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        return best;
      }

      function currentIndex() {
        if (desktopGallery()) {
          var current = slides.findIndex(function (slide) {
            return slide.classList.contains('is-current');
          });
          return current >= 0 ? current : 0;
        }
        return indexFromScroll();
      }

      function paintSlide(i) {
        if (typeof i !== 'number' || i !== i) i = currentIndex();
        i = Math.max(0, Math.min(slides.length - 1, Math.round(i)));
        slides.forEach(function (slide, si) {
          slide.classList.toggle('is-current', si === i);
        });
        thumbs.forEach(function (thumb, ti) {
          thumb.classList.toggle('is-active', ti === i);
        });
        if (indexEl) indexEl.textContent = (i + 1) + '/' + slides.length;
        dots.forEach(function (dot, di) {
          dot.classList.toggle('is-active', di === i);
        });
      }

      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        paintSlide(i);
        if (desktopGallery()) return;
        var slide = slides[i];
        var media = slide.querySelector('img, video');
        var inset = media ? (media.offsetLeft - slide.offsetLeft) : 16;
        track.scrollTo({ left: Math.max(0, slide.offsetLeft + inset - 24), behavior: 'smooth' });
      }

      function go(delta) {
        goTo(currentIndex() + delta);
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          if (desktopGallery()) return;
          paintSlide(indexFromScroll());
        });
      }, { passive: true });
      var prev = qs(set, '[data-snx-gallery-prev]');
      var next = qs(set, '[data-snx-gallery-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      dots.forEach(function (dot, di) {
        dot.addEventListener('click', function () { goTo(di); });
      });
      thumbs.forEach(function (thumb, ti) {
        thumb.addEventListener('click', function () { goTo(ti); });
      });
      set._snxGoTo = goTo;

      var drag = { on: false, startX: 0, startLeft: 0, moved: false };
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        if (desktopGallery()) return;
        drag.on = true;
        drag.moved = false;
        drag.startX = e.clientX;
        drag.startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });
      track.addEventListener('pointermove', function (e) {
        if (!drag.on) return;
        var dx = e.clientX - drag.startX;
        if (Math.abs(dx) > 4) drag.moved = true;
        track.scrollLeft = drag.startLeft - dx;
      });
      function endDrag() {
        if (!drag.on) return;
        drag.on = false;
        track.classList.remove('is-dragging');
        if (drag.moved) goTo(currentIndex());
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function (e) {
        if (drag.moved) e.preventDefault();
        drag.moved = false;
      }, true);

      paintSlide();
    });
  }

  function syncGallery(root, name) {
    qsa(root, '[data-snx-gallery-set]').forEach(function (set) {
      var key = (set.getAttribute('data-snx-gallery-set') || '').replace('color:', '');
      var match = key === 'all' || colorMatch(key, name) || key.toLowerCase().indexOf(String(name).toLowerCase()) !== -1;
      set.classList.toggle('is-active', match);
      if (match && typeof set._snxGoTo === 'function') set._snxGoTo(0);
    });
  }

  function openCart(opts) {
    opts = opts || {};
    var kit = document.documentElement.getAttribute('data-storefront-kit');
    if (kit === 'next') {
      document.dispatchEvent(new CustomEvent('snx:cart-added', {
        bubbles: true,
        detail: {
          kind: opts.kind || 'catcher',
          includesBags: !!opts.includesBags,
          sheet: 'upsell',
          title: opts.title || '',
          color: opts.color || '',
          response: opts.response || {}
        }
      }));
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var classic = document.querySelector('a.header__cart-link[href*="/cart"]');
    if (classic) classic.click();
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok || body.status) {
          throw new Error(body.description || body.message || 'Could not add to cart');
        }
        return body;
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.spsBound === 'true') return;
    root.dataset.spsBound = 'true';

    var map = parseMap(root);
    var bagsMode = root.getAttribute('data-mode') === 'bags';
    var priceEl = qs(root, '[data-sps-price]');
    var compareEl = qs(root, '[data-sps-compare]');
    var errorEl = qs(root, '[data-sps-error]');
    var atc = qs(root, '[data-sps-atc]');
    var colorBtns = qsa(root, '[data-sps-color]');
    var packBtns = qsa(root, '[data-sps-pack]');
    var purchaseBtns = qsa(root, '[data-sps-purchase-mode]');

    function isSubscribe() {
      return root.getAttribute('data-sps-offer') === 'subscription';
    }

    function setOffer(mode) {
      var next = mode === 'subscription' ? 'subscription' : 'one_time';
      root.setAttribute('data-sps-offer', next);
      root.classList.toggle('is-subscribe', next === 'subscription');
      purchaseBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-sps-purchase-mode') === next;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      paint();
    }

    function selectedColor() {
      var on = colorBtns.find(function (btn) {
        return btn.getAttribute('aria-pressed') === 'true';
      });
      return (on && on.getAttribute('data-color')) || root.getAttribute('data-color') || '';
    }

    function variantFromUrl() {
      try {
        return new URL(window.location.href).searchParams.get('variant') || '';
      } catch (err) {
        return '';
      }
    }

    function selectColor(name) {
      if (!name) return;
      colorBtns.forEach(function (btn) {
        var on = colorMatch(btn.getAttribute('data-color'), name) || btn.getAttribute('data-color') === name;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('is-selected', on);
      });
    }

    function selectedPack() {
      var on = packBtns.find(function (btn) {
        return btn.getAttribute('aria-pressed') === 'true';
      });
      return on || null;
    }

    function packOffer(variant) {
      if (!variant) return { price: 0, compare: 0, plan: null };
      var plan = isSubscribe() ? matchBagPlan(variant.selling_plans, variant.size) : null;
      if (plan) {
        return {
          price: plan.price,
          compare: plan.compare_at_price || variant.compare || variant.price,
          plan: plan
        };
      }
      return { price: variant.price, compare: variant.compare, plan: null };
    }

    function bagCartItem(variant) {
      if (!variant || !variant.id) return null;
      var item = { id: variant.id, quantity: 1 };
      if (!isSubscribe()) return item;
      var plan = matchBagPlan(variant.selling_plans, variant.size);
      if (!plan || !plan.id) return { error: 'plan' };
      item.selling_plan = plan.id;
      return item;
    }

    function paintPackImages(color) {
      var fam = family(color);
      packBtns.forEach(function (btn) {
        var img = qs(btn, '[data-sps-pack-img]');
        if (!img) return;
        var teal = btn.getAttribute('data-img-teal') || '';
        var pink = btn.getAttribute('data-img-pink') || '';
        var next = fam === 'pink' ? pink || teal : teal || pink;
        if (next) img.setAttribute('src', next);
      });
    }

    function packShown(btn, name) {
      return btn.getAttribute(name) !== 'hide';
    }

    function packText(btn, name) {
      return (btn.getAttribute(name) || '').trim();
    }

    function paintPackPrices(color) {
      packBtns.forEach(function (btn) {
        var size = btn.getAttribute('data-size');
        var variant = findBag(map, color, size);
        var price = qs(btn, '[data-sps-pack-price]');
        var compare = qs(btn, '[data-sps-pack-compare]');
        var badge = qs(btn, '[data-sps-pack-save]');
        var interval = qs(btn, '[data-sps-pack-interval]');
        var showInterval = packShown(btn, 'data-interval-visibility');
        var showCompare = packShown(btn, 'data-compare-visibility');
        var showSave = packShown(btn, 'data-save-visibility');
        var customInterval = packText(btn, 'data-interval-label');
        var customCompare = packText(btn, 'data-compare-label');
        var saveTpl = packText(btn, 'data-save-label') || 'SAVE [pct]%';
        if (!variant) {
          setMoney(price, 0, true);
          if (compare) {
            if (customCompare && showCompare) {
              compare.hidden = false;
              compare.textContent = customCompare;
            } else {
              setMoney(compare, 0, true);
            }
          }
          if (badge) {
            if (showSave && saveTpl.indexOf('[pct]') === -1 && saveTpl) {
              badge.hidden = false;
              badge.textContent = saveTpl;
            } else {
              badge.hidden = true;
            }
          }
          if (interval) interval.hidden = true;
          return;
        }
        var offer = packOffer(variant);
        var showSub = isSubscribe() && offer.plan;
        setMoney(price, offer.price, false);
        if (compare) {
          if (!showCompare) {
            compare.hidden = true;
          } else if (customCompare) {
            compare.hidden = false;
            compare.textContent = customCompare;
          } else {
            setMoney(compare, offer.compare > offer.price ? offer.compare : 0, true);
          }
        }
        if (interval) {
          var intervalKey = packSizeKey(size) === '180' ? 'data-interval-180' : 'data-interval-90';
          var intervalLabel = customInterval || root.getAttribute(intervalKey) || '';
          if (intervalLabel) interval.textContent = intervalLabel;
          interval.hidden = !showInterval || !showSub;
        }
        if (badge) {
          var pct = offer.compare > offer.price
            ? Math.round((1 - offer.price / offer.compare) * 100)
            : 0;
          if (!showSave) {
            badge.hidden = true;
          } else if (saveTpl.indexOf('[pct]') === -1) {
            if (saveTpl) {
              badge.hidden = false;
              badge.textContent = saveTpl;
            } else {
              badge.hidden = true;
            }
          } else if (pct > 0) {
            badge.hidden = false;
            badge.textContent = saveTpl.replace('[pct]', String(pct));
          } else {
            badge.hidden = true;
          }
        }
        btn.setAttribute('data-variant-id', String(variant.id || ''));
        btn.disabled = variant.available === false;
      });
    }

    function setVariantUrl(id) {
      if (!id || !window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(id));
        window.history.replaceState({}, '', url.toString());
      } catch (err) {}
    }

    function paintProductPrice(color) {
      if (bagsMode) {
        var pack = selectedPack();
        var bag = pack && findBag(map, color, pack.getAttribute('data-size'));
        if (!bag) return;
        var offer = packOffer(bag);
        setMoney(priceEl, offer.price, false);
        setMoney(compareEl, offer.compare > offer.price ? offer.compare : 0, true);
        root.setAttribute('data-variant-id', String(bag.id || ''));
        root.setAttribute('data-color', color || '');
        setVariantUrl(bag.id);
        return;
      }
      var source = findCatcher(map, color);
      if (!source) return;
      setMoney(priceEl, source.price, false);
      setMoney(compareEl, source.compare, true);
      root.setAttribute('data-variant-id', String(source.id || ''));
      root.setAttribute('data-color', color || '');
      setVariantUrl(source.id);
    }

    function paint(color) {
      var next = color || selectedColor();
      paintPackImages(next);
      paintPackPrices(next);
      paintProductPrice(next);
      applyTheme(next);
      syncGallery(root, next);
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    colorBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectColor(btn.getAttribute('data-color'));
        paint(btn.getAttribute('data-color'));
      });
    });

    packBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var already = btn.getAttribute('aria-pressed') === 'true';
        if (bagsMode && already) return;
        packBtns.forEach(function (other) {
          var on = !already && other === btn;
          other.setAttribute('aria-pressed', on ? 'true' : 'false');
          other.classList.toggle('is-selected', on);
        });
        paint();
      });
    });

    purchaseBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOffer(btn.getAttribute('data-sps-purchase-mode'));
      });
    });

    if (atc) {
      atc.addEventListener('click', function () {
        showError('');
        var color = selectedColor();
        var items = [];
        if (bagsMode) {
          var pack = selectedPack();
          var bag = pack && findBag(map, color, pack.getAttribute('data-size'));
          var bagItem = bagCartItem(bag);
          if (!bagItem || bagItem.error === 'plan') {
            showError(
              bagItem && bagItem.error === 'plan'
                ? root.getAttribute('data-error-plan')
                : root.getAttribute('data-error-pack') || 'Choose a pack.'
            );
            return;
          }
          items.push(bagItem);
        } else {
          var catcher = findCatcher(map, color);
          if (!catcher || !catcher.id) return;
          items.push({ id: catcher.id, quantity: 1 });
          var addon = selectedPack();
          var addonVar = addon && findBag(map, color, addon.getAttribute('data-size'));
          if (addonVar && addonVar.id) {
            var addonItem = bagCartItem(addonVar);
            if (addonItem && addonItem.error === 'plan') {
              showError(root.getAttribute('data-error-plan') || '');
              return;
            }
            if (addonItem) items.push(addonItem);
          }
        }

        atc.disabled = true;
        addItems(items)
          .then(function (added) {
            openCart({
              kind: bagsMode ? 'bags' : 'catcher',
              includesBags: bagsMode || items.length > 1,
              title: root.getAttribute('data-product-title') || '',
              color: color,
              response: added
            });
          })
          .catch(function (err) {
            showError(err.message || root.getAttribute('data-error-generic') || 'Could not add to cart.');
          })
          .finally(function () {
            atc.disabled = false;
          });
      });
    }

    var urlVariant = variantFromUrl();
    if (urlVariant) {
      var urlBtn = colorBtns.find(function (btn) {
        return String(btn.getAttribute('data-variant-id')) === String(urlVariant);
      });
      if (urlBtn) selectColor(urlBtn.getAttribute('data-color'));
    }

    initGallery(root);
    paint();
  }

  function boot() {
    qsa(document, '[data-sps]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    qsa(event.target, '[data-sps]').forEach(function (node) {
      node.dataset.spsBound = '';
      init(node);
    });
  });
})();
